import { render, staticRenderFns } from "./AddToSequence.vue?vue&type=template&id=0f270dd6&scoped=true"
import script from "./AddToSequence.vue?vue&type=script&lang=js"
export * from "./AddToSequence.vue?vue&type=script&lang=js"
import style0 from "./AddToSequence.vue?vue&type=style&index=0&id=0f270dd6&prod&lang=scss"
import style1 from "./AddToSequence.vue?vue&type=style&index=1&id=0f270dd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f270dd6",
  null
  
)

export default component.exports